import { AggregationAnalysisEffects } from './aggregation-analysis.effects'
import { AGGREGATION_ANALYSIS_FACADE, AggregationAnalysisFacade } from './aggregation-analysis.facade'
import { aggregationAnalysisState } from './aggregation-analysis.reducer'
import { aggregationAnalysisFeatureKey } from './aggregation-analysis.state'

export * from './aggregation-analysis.constant'
export * from './aggregation-analysis.facade'
export * from './aggregation-analysis.columns'

export const AGGREGATION_ANALYSIS_REDUCER = { [aggregationAnalysisFeatureKey]: aggregationAnalysisState }
export const AGGREGATION_ANALYSIS_PROVIDERS = [
  { provide: AGGREGATION_ANALYSIS_FACADE, useClass: AggregationAnalysisFacade },
]
export const AGGREGATION_ANALYSIS_EFFECTS = [AggregationAnalysisEffects]
